module.exports = __webpack_public_path__ + "img/3-7-3.dacf4587.png";